'use client';

import Image from 'next/image';
import Link from 'next/link';

export default function Footer() {
  const openCookieSettings = () => {
    window.dispatchEvent(new Event('open-cookie-settings'));
  };

  return (
    <footer id="contact">
      <div className="footer-content">
        <h3>Těším se na spolupráci 👋,</h3>
        <h3 className="quote">
          napište mi o Vašem projektu na{' '}
          <a href="mailto:hi@jakubmatuska.cz">
            hi@jakubmatuska.cz
            <span className="hey" style={{ minWidth: '140px' }}>Napište mi e-mail</span>
          </a>
          <br />
          nebo zavolejte na{' '}
          <a href="tel:+420774801300">
            +420 774 801 300
            <span className="hey" style={{ minWidth: '130px' }}>nebo zavolejte</span>
          </a>
          .<br />
        </h3>
        <div className="copy">
          <div className="copy-top">
            <p>Copyright 2022 © Jakub Matuška | IČ: 06006124</p>
            <ul className="legal-links">
              <li><Link href="/ochrana-osobnich-udaju">Ochrana osobních údajů</Link></li>
              <li><Link href="/cookies">Zásady cookies</Link></li>
              <li><button type="button" onClick={openCookieSettings} className="footer-link-btn">Nastavení cookies</button></li>
            </ul>
          </div>
          <ul className="social-icons">
            <li>
              <a target="_blank" href="https://www.facebook.com/jakubmatuskaweb" rel="noopener noreferrer">
                <Image width={50} height={50} src="/images/icons/fb.png" alt="Facebook" style={{ marginRight: '5px', marginBottom: '2px' }} />
                Facebook
              </a>
            </li>
            <li>
              <a target="_blank" href="https://www.instagram.com/jakubmatuskaweb/" rel="noopener noreferrer">
                <Image width={50} height={50} src="/images/icons/ig.png" alt="Instagram" />
                Instagram
              </a>
            </li>
            <li>
              <a target="_blank" href="https://www.linkedin.com/in/jakub-matu%C5%A1ka-88522a91/" rel="noopener noreferrer">
                <Image width={50} height={50} src="/images/icons/linkedin.png" alt="LinkedIn" />
                LinkedIn
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
